/* tslint:disable */
/* eslint-disable */
/**
 * GateHouse AIS REST interface
 * AIS system for monitoring vessel traffic. Commercial WebService. Contact GateHouse support for more information.
 *
 * The version of the OpenAPI document: 0.2.2
 * Contact: support@gatehouse.dk
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { PositionX } from './PositionX';
import {
    PositionXFromJSON,
    PositionXFromJSONTyped,
    PositionXToJSON,
} from './PositionX';
import type { ShipPositionItemShip } from './ShipPositionItemShip';
import {
    ShipPositionItemShipFromJSON,
    ShipPositionItemShipFromJSONTyped,
    ShipPositionItemShipToJSON,
} from './ShipPositionItemShip';

/**
 * Position Report for a vessel.
 * @export
 * @interface ShipPositionItem
 */
export interface ShipPositionItem {
    /**
     * 
     * @type {PositionX}
     * @memberof ShipPositionItem
     */
    position?: PositionX;
    /**
     * 
     * @type {ShipPositionItemShip}
     * @memberof ShipPositionItem
     */
    ship?: ShipPositionItemShip;
    /**
     * Navigational status as indicated by the AIS information.
     * @type {number}
     * @memberof ShipPositionItem
     */
    navstatus?: number;
    /**
     * Heading in degrees 0..359
     * @type {number}
     * @memberof ShipPositionItem
     */
    heading?: number;
    /**
     * Rate of Turn as indicated by the AIS message -127..127
     * @type {number}
     * @memberof ShipPositionItem
     */
    rot?: number;
}

/**
 * Check if a given object implements the ShipPositionItem interface.
 */
export function instanceOfShipPositionItem(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function ShipPositionItemFromJSON(json: any): ShipPositionItem {
    return ShipPositionItemFromJSONTyped(json, false);
}

export function ShipPositionItemFromJSONTyped(json: any, ignoreDiscriminator: boolean): ShipPositionItem {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'position': !exists(json, 'position') ? undefined : PositionXFromJSON(json['position']),
        'ship': !exists(json, 'ship') ? undefined : ShipPositionItemShipFromJSON(json['ship']),
        'navstatus': !exists(json, 'navstatus') ? undefined : json['navstatus'],
        'heading': !exists(json, 'heading') ? undefined : json['heading'],
        'rot': !exists(json, 'rot') ? undefined : json['rot'],
    };
}

export function ShipPositionItemToJSON(value?: ShipPositionItem | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'position': PositionXToJSON(value.position),
        'ship': ShipPositionItemShipToJSON(value.ship),
        'navstatus': value.navstatus,
        'heading': value.heading,
        'rot': value.rot,
    };
}

